import React, { useEffect, useState } from 'react';
import { SelectArrayInputProps } from 'react-admin';

import { SelectArrayInput } from '@components';
import { UserChannel, userHttp } from '@network';

export const DealerChannelFilter = (props: SelectArrayInputProps) => {
  const [options, setOptions] = useState<UserChannel[]>([]);

  useEffect(() => {
    (async () => {
      const list: UserChannel[] = await userHttp.getSources();
      setOptions(list.map(i => ({ id: i.name, name: i.name }))
        .sort((a, b) => a.name > b.name ? 1 : -1));
    })();
  }, []);

  return (
    <SelectArrayInput
      {...props}
      choices={options}
      className="MS-field"
      style={{ width: 280 }}
      alwaysOn
    />
  );
};
